import { createSelector } from 'reselect';

import { createParameterSelector, type OperationStatus } from '@pressreader/appstore';
import type { IssuePageSet } from '@pressreader/social-types';

import { getModuleState } from '../reducers';

const getState = createSelector(getModuleState, state => state.issuePageSet);

const getStatePageSet = createSelector(getState, state => state.pageSet);

const selectPageSetId = createParameterSelector<'pageSetId', string>('pageSetId');
const selectPageSetStateById = createSelector(getStatePageSet, selectPageSetId, (statePageSet, pageSetId) =>
    pageSetId ? statePageSet[pageSetId] : undefined,
);

const selectPageSetStatusById = createSelector(selectPageSetStateById, (pageSetState): OperationStatus | undefined => pageSetState?.status);
const selectPageSetById = createSelector(selectPageSetStateById, (pageSetState): IssuePageSet | undefined => pageSetState?.pageSet);

const selectPageSetCollectionsState = createSelector(getState, state => state.pageSetCollections);
const selectPageSetCollectionsStateById = createSelector(
    selectPageSetCollectionsState,
    selectPageSetId,
    (statePageSetCollections, pageSetId) => statePageSetCollections[pageSetId],
);
const selectPageSetCollections = createSelector(selectPageSetCollectionsStateById, state => state?.collections);
const selectPageSetCollectionsStatus = createSelector(selectPageSetCollectionsStateById, state => state?.status);

export { selectPageSetById, selectPageSetCollections, selectPageSetCollectionsStatus, selectPageSetStatusById };
